import { createContext } from "react";

export const LoadingBarSlotContext = createContext<HTMLElement | null>(null);
